import React from 'react';
import { Header } from 'semantic-ui-react';
import logo from '../assets/logo.svg';

const TitleBar = () => (
	<Header as="h1" color="grey" style={{ textAlign: 'center', padding: '20px' }}>
		<img src={logo} alt="Weather App logo" /> Weather App
	</Header>
);

export default TitleBar;



// WEBPACK FOOTER //
// ./src/components/TitleBar.js